module.exports = __webpack_public_path__ + "assets/img/video.af56bf88.png";